export default "__VITE_ASSET__BRGgCQVE__"